<template>
    <div class="search-card">
        <template v-if="periodico.tpPublicacao == null || periodico.tpPublicacao == 'upload'">
            <router-link :to="{ name: 'LeitorPdf', params: { idPeriodico: periodico.idPeriodico } }"
                         class="search-card__link">
                <div class="search-card__cover">
                    <div class="search-card__badge">{{ getMes(periodico.dtPublicacao) }}/{{ getAno(periodico.dtPublicacao) }}</div>
                    <img class="search-card__img"
                         :src="periodico.urlImgPeriodico"
                         :alt="periodico.dsTitulo"
                         onerror="this.onerror=null; this.src='/image-not-found.jpg'" />
                    <div class="search-card__hover">
                        <span class="search-card__cta">
                            Ler agora
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                        </span>
                    </div>
                </div>
                <div class="search-card__body">
                    <p class="search-card__title">{{ periodico.dsTitulo }}</p>
                    <p class="search-card__date">Edição de {{ getMes(periodico.dtPublicacao) }}/{{ getAno(periodico.dtPublicacao) }}</p>
                    <p class="search-card__ref">{{ periodico.dsReferencia }}</p>
                </div>
            </router-link>
        </template>

        <template v-else>
            <router-link :to="{ name: 'Revista', params: { idPeriodico: periodico.idPeriodico } }"
                         class="search-card__link"
                         target="_blank">
                <div class="search-card__cover">
                    <div class="search-card__badge">{{ getMes(periodico.dtPublicacao) }}/{{ getAno(periodico.dtPublicacao) }}</div>
                    <img class="search-card__img"
                         :src="periodico.urlImgPeriodico"
                         :alt="periodico.dsTitulo"
                         onerror="this.onerror=null; this.src='/image-not-found.jpg'" />
                    <div class="search-card__hover">
                        <span class="search-card__cta">
                            Ler agora
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                        </span>
                    </div>
                </div>
                <div class="search-card__body">
                    <p class="search-card__title">{{ periodico.dsTitulo }}</p>
                    <p class="search-card__date">Edição de {{ getMes(periodico.dtPublicacao) }}/{{ getAno(periodico.dtPublicacao) }}</p>
                    <p class="search-card__ref">{{ periodico.dsReferencia }}</p>
                </div>
            </router-link>
        </template>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        name: 'BoxPeriodicoPesquisa',
        components: {},
        computed: {
            user() { return this.$store.state.user },
        },
        data() {
            return {  }
        },
        props: {
            periodico: { type: Object, required: true },
        },
        methods: {
            getMes(dt) { return moment(dt).format('MM') },
            getAno(dt) { return moment(dt).format('YYYY') },
        },
    }
</script>

<style lang="scss" scoped>
    .search-card {
        --gold: #C8922A;
        --gold-light: #E8A83A;
        --dark: #1A1A2E;
        --muted: #7a7060;
        --border: #DEDBD4;
        --border-gold: rgba(200, 146, 42, 0.3);
        --shadow-sm: 0 2px 8px rgba(26, 26, 46, 0.07);
        --shadow-lg: 0 20px 60px rgba(26, 26, 46, 0.14);
        height: 100%;
    }

    .search-card__link {
        display: flex;
        flex-direction: column;
        height: 100%;
        text-decoration: none !important;
        color: inherit;
        background: #fff;
        border: 1px solid var(--border);
        border-radius: 12px;
        overflow: hidden;
        box-shadow: var(--shadow-sm);
        transition: transform 0.3s, border-color 0.3s, box-shadow 0.3s;

        &:hover {
            transform: translateY(-5px);
            border-color: var(--gold);
            box-shadow: var(--shadow-lg), 0 0 0 1px var(--border-gold);

            .search-card__img {
                transform: scale(1.04);
            }

            .search-card__hover {
                opacity: 1;
            }
        }
    }

    /* ── CAPA ── */
    .search-card__cover {
        position: relative;
        aspect-ratio: 3 / 4;
        overflow: hidden;
        background: #e8e3d8;
        border-bottom: 1px solid var(--border);
        flex-shrink: 0;
    }

    .search-card__badge {
        position: absolute;
        top: 0.65rem;
        right: 0.65rem;
        z-index: 3;
        background: var(--gold);
        color: #fff;
        font-size: 0.6rem;
        font-weight: 700;
        letter-spacing: 0.1em;
        padding: 0.25rem 0.55rem;
        border-radius: 3px;
        font-family: 'DM Mono', monospace;
    }

    .search-card__img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center top;
        display: block;
        transition: transform 0.4s ease;
    }

    /* Overlay hover */
    .search-card__hover {
        position: absolute;
        inset: 0;
        background: linear-gradient(to top, rgba(26, 26, 46, 0.85) 0%, rgba(26, 26, 46, 0.1) 60%, transparent 100%);
        display: flex;
        align-items: flex-end;
        justify-content: center;
        padding-bottom: 1.25rem;
        opacity: 0;
        transition: opacity 0.3s;
        z-index: 2;
    }

    .search-card__cta {
        display: inline-flex;
        align-items: center;
        gap: 0.35rem;
        background: var(--gold);
        color: #fff;
        font-family: 'DM Sans', sans-serif;
        font-size: 0.7rem;
        font-weight: 700;
        letter-spacing: 0.09em;
        text-transform: uppercase;
        padding: 0.45rem 1rem;
        border-radius: 4px;
    }

    /* ── BODY ── */
    .search-card__body {
        padding: 1rem 1rem 1.25rem;
        display: flex;
        flex-direction: column;
        gap: 0.3rem;
        flex: 1;
    }

    .search-card__title {
        font-family: 'Playfair Display', serif;
        font-size: 0.95rem;
        font-weight: 700;
        color: var(--dark);
        line-height: 1.35;
        margin: 0;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .search-card__date {
        font-size: 0.7rem;
        color: var(--gold);
        font-weight: 600;
        margin: 0;
        letter-spacing: 0.04em;
    }

    .search-card__ref {
        font-size: 0.78rem;
        color: var(--muted);
        line-height: 1.5;
        margin: 0;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        flex: 1;
    }
</style>